import { reactive, ref, computed, watch } from 'vue'
import { getUrlParams } from '../../utils'
import { getTeamsList, getTeams } from '../../api'

function useTeamSwiper() {
    const active = Number(getUrlParams().index)

    const tames = reactive({
        imgs: [],
        names: [],
        introduc: [],
        list: [],
        teamsActive: active ? (active > 9 ? 0 : active) : 0,
        isShowMax: false
    })

    watch(() => tames.isShowMax, function (val) {
        if (!val) {
            _createTime()
        }
    })

    const teamplayers = computed(() => tames.list[tames.teamsActive] || [])

    function switchActive(index) {
        tames.teamsActive = index
    }

    getTeams().then(res=>{
        console.log(res.length);
        if(res && res.length > 0) {
            let teamString = [];
            let name = [];
            let introduc = [];
            let _imgs = [];
            res.forEach(item => {
                teamString.push(item.slug);
                name.push(item.name);
                introduc.push(item.description);
                _imgs.push(item.icon);
            });
            // console.log(teamString.join());
            tames.names = name;
            tames.introduc = introduc;
            tames.imgs = _imgs;
            // console.log(introduc);
            let url = '/wp-json/wolves/v1/players?team='+teamString.join();
            getTeamsList(url)
            .then(function (data) {
                tames.list = data
                // _createTime()
            })
        }
    })

    // getTeamsList('/wp-json/wolves/v1/players?team=rainbow-six-siege,honor-of-king,fifa-online4,identity5,call-of-duty-mobile,qq-speed,content-creators')
    //     .then(function (data) {
    //         tames.list = data
    //         // _createTime()
    //     })

    let index

    function showMaxSwiper(_index) {
     
        // if (tames.teamsActive === 4) return
        index = _index
        tames.isShowMax = true
    }

    function onSwiper(swiper) {

        swiper.slideTo(index, 0)
    }

    function mouseover() {
        // _clearTime()
    }

    function mouseleave() {
        if (tames.isShowMax) return
        // _createTime()
    }

    // let timer

    function _createTime() {
        // _clearTime()
        // timer = setInterval(function () {
        //     let active = tames.teamsActive + 1
        //     if (active === 7) {
        //         active = 0
        //     }
        //     tames.teamsActive = active
        // }, 5000)
    }

    function _clearTime() {
        // clearInterval(timer)
    }
    let swiper_options = reactive({
        autoplay: {
          disableOnInteraction: false, // 鼠标滑动后继续自动播放
          delay: 4000, //4秒切换一次
        },
        speed: 500, //切换过渡速度
        loop: true,
        slidesPerView: "auto", //解决最后一张切换到第一张中间的空白
        centeredSlides: true, //设置slide居中
        spaceBetween: 20,
        coverflowEffect: {
          // rotate: 0, //slide做3d旋转时Y轴的旋转角度。默认50。
          stretch: 50, //每个slide之间的拉伸值（距离），越大slide靠得越紧。 默认0。
          depth: 100, //slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
          modifier: 1, //depth和rotate和stretch的倍率，相当于            depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
          // slideShadows: false, //开启slide阴影。默认 true。
        },
        navigation: {
          nextElRef: ".swiper-button-next",
          prevElRef: ".swiper-button-prev",
        },
        pagination: {
          clickable: true,
        },
      });
    return {
        swiper_options,
        tames,
        teamplayers,
        showMaxSwiper,
        onSwiper,
        mouseover,
        mouseleave,
        switchActive,
    }
} 

function useSetNavigation() {
    const teamsSwiper = ref()

    function onTeamsSwiper(swiper) {
        teamsSwiper.value = swiper
    }
    return {
        onTeamsSwiper,
        teamsSwiper,
    }
}

export {
    useTeamSwiper,
    useSetNavigation
}